import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import List from 'components/list/list';
import Pagination from 'components/pagination';
import ListScenarioRow from 'views/bluviu-nutrition/features/scenarios/components/list-scenario-row';
import { ScenarioListItem } from 'views/bluviu-nutrition/features/scenarios/types/scenario-list-item.type';
import { usePagination } from 'hooks/use-pagination';
import { Box } from '@mui/material';

type Props = {
  scenarios: ScenarioListItem[];
  setScenarios: React.Dispatch<React.SetStateAction<ScenarioListItem[]>>;
};

const ListScenarios: React.FC<Props> = ({ scenarios, setScenarios }) => {
  const intl = useIntl();
  const PAGINATION_LIMIT = 10;
  const PAGE_NAME_ID = 'bluViuNutrition.listScenarios';

  // FORMS

  // STATE
  const { currentPage, from, to, handlePagination } = usePagination(PAGINATION_LIMIT);

  // FETCH DATA

  // #region HANDLERS

  // #endregion HANDLERS

  useEffect(() => {
    handlePagination(1); // reset when scenarios list is updated
  }, [scenarios]);

  return (
    <Box display={'flex'} flexDirection={'column'} gap={4}>
      <List
        options={[
          { id: 'name', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.nameLabel` }) },
          { id: 'model', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.modelLabel` }) },
          { id: 'updatedDate', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.updatedDateLabel` }) },
          { id: 'state', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.stateLabel` }) },
          { id: 'actions', label: '', align: 'center', autoWidth: true },
        ]}
        orderBy="updatedDate"
        rows={scenarios}
        sort={setScenarios}
        noResult={{
          show: scenarios.length <= 0,
          text: <FormattedMessage id={`${PAGE_NAME_ID}.list.noResults`} />,
        }}>
        {scenarios.slice(from, to).map((scenario, idx) => (
          <ListScenarioRow scenario={scenario} key={idx} />
        ))}
      </List>
      <Pagination currentPage={currentPage} pages={Math.ceil(scenarios.length / PAGINATION_LIMIT)} onClick={handlePagination} />
    </Box>
  );
};

export default React.memo(ListScenarios);
